// extracted by mini-css-extract-plugin
export default {"notfound":"notFound_notfound__v5CFU","notfound-404":"notFound_notfound-404__3+oqm","back":"notFound_back__8POfW"};